import { useMemo } from 'react';
import classNames from 'classnames';
import type { Category } from '@/interfaces/strapi';
import { generatePath, Link } from 'react-router-dom';
import { ROUTES } from '@/constants';

type BlogCategoriesItemProps = {
	readonly className?: string;
	readonly category: Category;
};

const classNameComponent = 'c-cnm-blog-categories-card';

export const BlogCategoriesItem = ({ className, category }: BlogCategoriesItemProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);

	return (
		<article className={wrapperClassName}>
			<Link
				to={generatePath(ROUTES.ACTUALIDAD_BY_CATEGORY, { category: category.slug })}
				className={`${classNameComponent}-link`}
			>
				<img src={category.image.url} alt={category.image.alt} className={`${classNameComponent}-image`} />
				<h4 className={`${classNameComponent}-title`}>{category.name}</h4>
				<p className={`${classNameComponent}-description`}>{category.description}</p>
			</Link>
		</article>
	);
};
